import React from 'react';
import { Box, Icon, IconId, Typography } from '@drone-js/core';
import { KeyInfoType } from 'component/page/detail/DetailCard/KeyInfos/KeyInfo.types';

interface Props {
    type: KeyInfoType;
    text: string;
    iconId: IconId;
}

export const KeyItem: React.FC<Props> = (props) => {
    if (!props.type || !props.text || !props.iconId) {
        return null;
    }

    return (
        <Box data-testid={`activities-details-${props.type}`} mb="12" display="flex" me="16">
            <Icon size="16" id={props.iconId} color="feedback.positive" label={props.text} />
            <Typography variant="body-default" ms="4" tag="span" textColor="base.default">
                {props.text}
            </Typography>
        </Box>
    );
};
KeyItem.displayName = 'KeyItem';
